// replaced in build process
export const SITE_MODE = 'REMEHA';

export const SITE_MODES = {
  REMEHA: 'REMEHA',
  RENSA: 'RENSA',
  TU: 'TU',
};




// WEBPACK FOOTER //
// ./js/config/site-mode.js